<script setup>
import TheViewTelegram from '@/pages_telegram/TheViewTelegram.vue';
import TheMainScreen from '@/components/sections/TheMainScreen.vue';
import ThePrizes from '@/components/sections/ThePrizes.vue';
import TheWinners from '@/components/sections/TheWinners.vue';
import TheFaq from '@/components/sections/TheFaq.vue';
import TheLine from '@/components/sections/TheLine.vue';
</script>
<template>
    <TheMainScreen />
    <ThePrizes />
    <TheLine />
    <TheWinners />
    <TheLine />
    <TheFaq />
</template>
<style lang='scss' scoped>
@use '@/assets/scss/base/vars';
</style>